import React from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../../components/components"
import { PositionMetadaten } from "../../models/positionMetadaten"
import { eventhandlingForLists } from "../hooks/EventhandlingForLists"
import { PositionZusatzinformationView } from "./PositionZusatzinformationView"

export interface PositionZusatzdatenListViewProps {
    positionMetadaten: PositionMetadaten[]
    path: string
}

export function PositionZusatzinformationListView({ path, positionMetadaten }: PositionZusatzdatenListViewProps) {
    const { remove, onChange, add } = eventhandlingForLists(path, () => new PositionMetadaten())
    const { t } = useTranslation()

    return (
        <Components.Collapsible title={t("rechnung.positionen.positionMetadaten.title")} collapsed={false} data-index={path}>
            {positionMetadaten.map((p, idx) => (
                <PositionZusatzinformationView
                    key={idx}
                    index={idx}
                    positionMetadaten={p}
                    path={path + "." + idx}
                    onChange={onChange(idx)}
                    onRemove={remove(idx)}
                />
            ))}

            <Components.Row>
                <Components.Col align={Components.Align.RIGHT}>
                    <Components.Button
                        style={Components.ButtonStyle.SECONDARY}
                        label={t("rechnung.positionen.positionMetadaten.neueMetadaten")}
                        onClick={add}
                    />
                </Components.Col>
            </Components.Row>
        </Components.Collapsible>
    )
}
